import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

export function isAlgunaSelfServeEnabled(flags: LDFlagSet): boolean {
  return flags.releaseAlgunaSelfServe === true;
}
